import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '@/helpers/ApiClient';

export const integrationService = {
    getIntegration,
    deleteIntegration,
    saveIntegration,

}

function getIntegration() {
    return apiClient.get('/integrations', {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function getIntegrationType() {
    return apiClient.get('/integrations/types', {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function getIntegrationByUser(user) {
    return apiClient.get(`/integrations/user/${user.userId}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function deleteIntegration(integration) {
    return apiClient.delete(`/integrations/${integration.id}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function saveIntegration(integration, isUpdate = false) {
    let config = {};

    if (integration.type === "CASHDRO") {
        config.ip = integration.ip
        config.username = integration.username;
        config.password = integration.password;
    } else if (integration.type === "CCV_OPI" || integration.type === "NEPT_OPI") {
        config.ip = integration.ip
        config.localPrint = integration.localPrint;
    } else if (integration.type === "CASH_BOX") {
        config.ip = integration.ip
        config.webtoolUrl = integration.webtoolUrl;
        config.username = integration.username;
        config.authKey = integration.authKey;
    } else if (integration.type === "CTEP") {
        config.serialNumber = integration.serialNumber;
    } else if (integration.type === "NEPTINGA2A") {
        config.serialNumber = integration.serialNumber;
    } else if (integration.type === "LOYALTEK") {
        config.url = integration.url;
        config.serialNumber = integration.serialNumber;
    } else if (integration.type === "CASHMATIC") {
        config.ip = integration.ip;
        config.username = integration.username;
        config.password = integration.password;
    }

    const body = {
        id: integration.id,
        orgId: integration.orgId,
        userId: integration.userId,
        type: integration.type,
        configJson: JSON.stringify(config)
    };

    const url = isUpdate
        ? `/integrations/${integration.id}`
        : `/integrations`;

    const request = isUpdate
        ? apiClient.patch(url, body, { headers: authHeader() })
        : apiClient.post(url, body, { headers: authHeader() });

    return request
        .then(res => res.data)
        .catch(handleError);
}






